<template>
	<!-- 我的考试 -->
	<div class="uni-exam-wrap makeUpExamSignUp">
        <!-- v-if="!isStart"  -->
		<div class="uni-exam-pay">
			<div class="continer">
				<Title text="补考报名"></Title>
                <div class="btn-box">
                    <div>
						<el-form
							ref="searchRef"
							class="curriculum-search"
							:inline="true"
							:model="condition"
							:rules="rules"
							label-width="80px"
						>
							<div class="curriculum-search_label">
								<el-form-item prop="exam_id">
									<el-select
										v-model="condition.exam_id"
										placeholder="请选择补考考试"
										clearable
										filterable
									>
										<el-option
											v-for="item in examList"
											:key="item.id"
											:label="item.title"
											:value="item.id"
										></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" @click="screenClick">确定</el-button>
								</el-form-item>
							</div>
						</el-form>
					</div>
                    <div>
                        <el-button v-if="is_allow_sign == 1" type="primary" @click="makeUpExamSignIn('batch')">批量报名</el-button>
                    </div>
                </div>
				<!-- filter-box -->
				<!-- <div class="box filter-box">
					<ul class="filter-list">
						<li class="item">
							<span class="tit">考试方式</span>
							<div>
								<el-radio v-for="(item, index) in course" :key="index" class="radio" v-model="courseModel" :label="item.val" @change="getListData">
									{{ item.name }}
								</el-radio>
							</div>
						</li>
						<!~~ <li class="item">
							<span class="tit">考试状态</span>
							<div>
								<el-radio v-for="(item, index) in progress" :key="index" class="radio" v-model="progressModel" :label="item.val" @change="getData">
									{{ item.name }}
								</el-radio>
							</div>
						</li> ~~>
					</ul>
				</div> -->

				<div class="elTable">
					<!-- table -->
					<el-table
                        :data="dataList"
                        headerRowClassName="uni-primary-table-header"
                        stripe border
                        empty-text="你没有待补考的课程！"
                        @selection-change="selectionChange">
                        <el-table-column type="selection" align="center" width="55" :selectable="selectable"></el-table-column>
						<!-- <el-table-column prop="exam_title" align="center" label="考试名称"></el-table-column> -->
						<!-- <el-table-column prop="exam_hall_start_time" align="center" label="考试时间" width="350">
							<template slot-scope="scope">
								{{ scope.row.exam_hall_start_time }} - {{ scope.row.exam_hall_end_time }}
							</template>
						</el-table-column> -->
						<el-table-column prop="title" align="center" label="课程名称"></el-table-column>
						<el-table-column prop="code" align="center" label="课程代码"></el-table-column>
						<el-table-column prop="code" align="center" label="是否报名">
                            <template slot-scope="{row}">
                                <el-tag :type="row.is_sign | isSignStyle">
                                    {{ row.is_sign == 0 ? '未报名' : '已报名' }}
                                </el-tag>
							</template>
                        </el-table-column>
						<!-- <el-table-column prop="exam_type" align="center" label="考试类型">
							<template slot-scope="scope">
								{{ course[scope.row.exam_type].name }}
							</template>
						</el-table-column> -->
						<!-- <el-table-column prop="exam_status_text" align="center" label="状态">
							<!~~ <template slot-scope="scope">
								<span>{{ progressMap[(scope.row.exam_status)-1] }}</span>
							</template> ~~>
						</el-table-column> -->
						<!-- <el-table-column prop="score" align="center" label="成绩">
							<template slot-scope="{ row }">
								{{ row.exam_status == 7 ? row.score : '--' }}
							</template>
						</el-table-column> -->
						<!-- <el-table-column prop="created_at" align="center" label="考试要求">
							<template v-slot="scoped">
								<el-button type="text" @click="handleExamine(scoped.row)" v-if="scoped.row.exam_type === 1">[查看]</el-button>
								<span v-else>无</span>
							</template>
						</el-table-column> -->
                        <el-table-column align="center" width="200" label="操作">
							<template slot-scope="{row}">
                                <el-button v-if="is_allow_sign == 1 && row.is_sign == 0" size="small" style="font-size: 12px" type="primary" @click="makeUpExamSignIn('single', row)">补考报名</el-button>
                                <span v-else>--</span>
                            </template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
        <!-- <div v-else class="empty">
            <ComponentEmpty
                style="padding: 0"
                imgClass="empty-img-size100"
                title="补考报名还未开始"
                tips=""
            />
        </div> -->
	</div>
</template>

<script>
import { adultStudentSupplyExamGet, adultStudentSupplyCourseGet, adultStudentSupplySign } from '@/api/exam';
// import { mapState } from 'vuex';
export default {
	name: 'makeUpExamSignUp',
    filters: {
        isSignStyle(v){
            let obj = {
                0: '',
                1: 'success',
            };
            return obj[v];
        },
    },
	data() {
		return {
            isStart: true,  //是否补考报名还未开始
            tipsTitle: '',  //提示
			// courseModel: 0,  //考试方式
			// course: [
			// 	{ name: '全部', val: 0 },
			// 	{ name: '线上考试', val: 1 },
			// 	{ name: '线下考试', val: 2 }
			// ],
			// progressModel: 0,
			dataList: [],
			examInfoVisible: false,
			examRegist: [],
			timer: [],
			getEndTime: [],
			userInfo: [],

			condition: {
				exam_id: '',
			},
			rules: {
				exam_id: [{ required: true, message: "请选择补考考试", trigger: "change" }],
			},
			examList: [],  //补考考试列表
            selecteList: [],  //表格选中的数据
			is_allow_sign: 0,  //是否允许报名
		};
	},
	created() {
		this.getExamData();  //获取考试信息
	},
	beforeDestroy() {
		// 清除定时器
		if (this.timer.length > 0) {
			this.timer.forEach(timer => {
				if (timer) {
					clearInterval(timer);
				}
			});
		}
	},
	methods: {
        // 补考报名
        makeUpExamSignIn(type, row){
            this.$confirm("此操作报名这些课程, 是否确认?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                let data = {
                    exam_id: this.condition.exam_id,
                };
                if(type === 'batch') {
                    if(this.selecteList.length <= 0){
                        this.$message.warning('请选择补考课程');
                        return;
                    }
                    data.course_ids = this.selecteList.toString();
                }else if(type === 'single'){
                    data.course_ids = row.id.toString();
                }
                adultStudentSupplySign(data).then(res => {
                    if(res.code == 200){
                        this.$message.success('报名成功');
                        this.getListData();  //获取考试信息
                    }
                });
            });
        },
        // 获取补考课程信息
        getListData(){
            let data = {
                exam_id: this.condition.exam_id,
            };
            adultStudentSupplyCourseGet(data).then(res => {
                if(res.code == 200){
                    this.dataList = res.result;
                }
            });
        },
		// 获取考试信息
		async getExamData() {
			let params = {};
			const { result } = await adultStudentSupplyExamGet(params);

			if (result) {
				this.examList = result;
                // this.isStart = false;
			}
		},
		screenClick(){
			this.$refs['searchRef'].validate(async (valid) => {
                if (valid) {
                    this.getListData();
					const currItem = this.examList.find(item => item.id == this.condition.exam_id);
					const {is_allow_sign} = currItem;
					this.is_allow_sign = is_allow_sign;
                }
            });
		},
        // 选择表格数据
        selectionChange(v){
            this.selecteList = v.map(item => item.id);
        },
        // 控制表格是否勾选
        selectable({is_sign}){
            return is_sign != 1;
        },
	}
};
</script>

<style lang="scss" scoped>
.uni-exam-wrap {
	min-height: $contentH;
	padding: $sideMargin;
	padding-bottom: 0;
}
.uni-exam-pay {
	min-height: inherit;
	background: #fff;

	.divider {
		width: 100%;
		height: 1px;
		background-color: #e9edf7;
	}
	.elTable {
		width: 100%;
		overflow: hidden;
        margin-top: 20px;
	}
	.continer {
		height: 100%;
		//overflow: hidden;
		padding: 0 20px 20px;
        .btn-box{
            display: flex;
            justify-content: space-between;
        }
	}

	.filter-box {
		.tit {
			font-size: 16px;
			font-weight: 600;
			margin-right: 20px;
		}

		.btn-box {
			padding: 0 20px;
			height: 30px;
		}

		.filter-list {
			.item {
				display: flex;
				align-items: center;
				padding: 0 20px;
				margin-bottom: 20px;

				&:last-child {
					border: none;
				}
			}
		}

	}
}
</style>
